import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import app from "@/firebaseConfig/config";

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '*',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/player/:id',
        name: 'Player',
        component: () => import('../views/Player.vue'),
        meta: {
            auth: true
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: ()=> import('../views/Register.vue')
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const user = app.auth().currentUser
    const auth = to.matched.some(record => record.meta.auth)
    if (auth && !user) {
        next('Login')
    } else {
        next()
    }
})

export default router
